var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3HeatingStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 27.11L32.49 17h5.28l-8.48 9.87 5.77 5.62-2.73 2.92-8.53-8.3zM38.31 29l11.18-12h-4.42l-8.69 10.11L38.31 29zm-22 23.64L19 49.69 16.71 47 27 36.93 16.71 26.87 25.19 17h-5.27l-8.69 10.11 10.07 9.82-10.07 9.81 5.08 5.9zM76 0h-5.22L18.91 55.69 0 76h5.45l17.69-19h2.18l-1-1.21 3.8-4.08 4.5 5.29h5.28l-7.08-8.24L44 34.57l2.42 2.36-10.04 9.81L45.2 57h5.27l-8.6-10L52.2 37l-5.43-5.29L50 28.15l9 8.78-10 9.81L57.78 57H63l-8.56-10 10.33-10-10.33-10.13L62.92 17h-2.51L76 .26V0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Heating_stop.b22b87f8.svg";
export { SvgB3HeatingStop as ReactComponent };